import React from "react";
import { useTranslation } from "react-i18next";

import Title from "components/common/Title";
import PageHeader from "components/common/layouts/App/PageHeader";
import OverviewListing from "pages/dev/overview/Overview";
import { CenterPageWrap } from "components/styled/mixins";

const Overview = () => {
  const { t } = useTranslation();
  const title = t("Overview");

  return (
    <CenterPageWrap>
      <Title>{title}</Title>
      <PageHeader
        title={title}
        breadcrumbs={[{ label: title }]}
        withBack={false}
      />
      <OverviewListing />
    </CenterPageWrap>
  );
};

export default Overview;
